<header class="bg-primary p-3">

  <div class="container">

    <nav class="navbar main-nav">

      <div class="logo">
        <img src="assets/imagens/logo_branca.png">
      </div>

      <ul class="float-right">
        <li class="drop-down">
          <a><i class="flag-icon {{ idiomaSelecionado.FLAG }}"></i><span
              class="d-none">{{ idiomaSelecionado.TITULO }}</span><i class="fas fa-angle-down ml-2"></i></a>
          <ul>
            <li *ngFor="let idioma of idiomas">
              <a *ngIf="idiomaSelecionado.CODIGO != idioma.CODIGO" (click)="alterarIdioma(idioma.CODIGO)"><i
                  class="flag-icon {{ idioma.FLAG }} mr-2"></i>{{ idioma.TITULO }}</a>
            </li>
          </ul>
        </li>
      </ul>

    </nav>

  </div>

</header>

<main>

  <div class="container">

    <div class="row mt-5 text-justify">
      <div class="col-md-12">
        <h2 class="text-center">{{ data.TITULO }}</h2>
          <p *ngFor="let cabecalho of data.CABECALHO">{{ cabecalho.TEXTO }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h4>{{ data.TITULO_TIPO }}</h4>
        <p><b>{{ data.SUBTITULO_TIPO }}</b></p>
        <ul>
          <li *ngFor="let cforma of data.FORMA_DADOS_COLETADOS">{{ cforma.TEXTO }}</li>
        </ul>
        <p><b>{{ data.TITULO_DADOS }}</b></p>
        <ul>
          <li *ngFor="let dados of data.DADOS_COLETADOS">{{ dados.TEXTO }}</li>
        </ul>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h4>{{ data.TITULO_USO_DADOS }}</h4>
        <p><b>{{ data.SUBTITULO_USO_DADOS }}</b></p>
        <ul>
          <li *ngFor="let uso of data.USO_DADOS">{{ uso.TEXTO }}</li>
        </ul>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h4>{{ data.TITULO_COOKIE }}</h4>

        <p><b>{{ data.SUBTITULO_COOKIE }}</b></p>

        <p *ngFor="let cookie of data.TEXTO_COOKIE">{{ cookie.TEXTO }}</p>

        <ul>
          <li *ngFor="let clink of data.LINK_COOKIE"><a class="btn btn-link" href="{{ clink.URL }}" target="_blank">{{ clink.LINK }}</a></li>
        </ul>

        <p><b>{{ data.TITULO_COOKIE_DEFINIDO }}</b></p>

        <ul>
          <li *ngFor="let cdefinido of data.COOKIE_DEFINIDO">
            <h6>{{ cdefinido.TITULO }}</h6>
            <p>{{ cdefinido.DESCRICAO }}</p>
          </li>
        </ul>

        <p><b>{{ data.TITULO_COOKIE_TERCEIRO }}</b></p>

        <p *ngFor="let cterceiro of data.TEXTO_COOKIE_TERCEIRO">{{ cterceiro.TEXTO }}</p>

        <ul>
          <li *ngFor="let cdescterceiro of data.DESCRICAO_COOKIE_TERCEIRO"><p>{{ cdescterceiro.TEXTO }}</p></li>
        </ul>

      </div>

    </div>

    <div class="row">
      <div class="col-md-12">
        <h4>{{ data.TITULO_PRIVACIDADE }}</h4>
        <p>{{ data.TEXTO_PRIVACIDADE }}</p>
      </div>
    </div>

  </div>

</main>